module.exports = __webpack_public_path__ + "46dd38c794893ab9b889c85615e5e574.MP3";